import React from "react"
import { graphql } from "gatsby"
// temp
import "../pages/index.css";

import Layout from "../components/layout"
import ArticleList from "../components/article-list"
import SEO from "../components/seo"
import Pagination from "../components/pagination"

export default ({data, pageContext}) => {
  let tag = data.tags.edges[0].node.frontmatter.label;
  if (pageContext.numberOfPages > 1) {
    tag = tag + ' / ' + pageContext.humanPageNumber;
  }
  return (
    <>
      <SEO title="Archivio" keywords={[data.tags.edges[0].node.frontmatter.label]} />
      <ArticleList tag={tag} articles={data.results.edges}
      paginator={() => (
        <Pagination pageContext={pageContext} />
      )}
      />
      </>
  )
}
export const query = graphql`
query($slug: String!, $skip: Int!, $limit: Int!) {
    results: allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC},
      filter: { frontmatter: {tags: { elemMatch: {frontmatter: {name: {eq: $slug}}}}}},
      skip: $skip,
      limit: $limit,
      ) {
        totalCount
        edges {
            node {
              frontmatter {
                title
                date
                author
                slug
                tags {
                  frontmatter{
                    name
                    label
                  }
                }
                thumbnail
              }
              html
              internal {
                type
                mediaType
                description
              }
              excerpt
              
            }
      
        }
    }
    tags: allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC},
      filter: { frontmatter: {name: {eq: $slug}}}) {
        edges {
          node {
            frontmatter {
              name
              label
            }
          }
        }
      }
  }
`